<template>
    <div>
        <v-form ref="form" v-model="valid">
            <v-toolbar dense flat color="transparent" class="toolbar-form">
                <v-toolbar-title>
                    <v-icon class="cursor-pointer back-icon" @click="goBack()">keyboard_arrow_left</v-icon>
                    {{ title }} Pedidos
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
            <div ref="printForm">
                <div class="workflow-state-form">
                </div>
                <grid-layout
                    :layout.sync="layout"
                    :col-num="12"
                    :row-height="rowHeight"
                    :is-draggable="false"
                    :is-resizable="false"
                    :is-mirrored="false"
                    :vertical-compact="true"
                    :margin="[10, 10]"
                    :use-css-transforms="true"
                    :responsive="true"
                    :cols="{lg: 12, md: 12, sm: 12, xs: 1, xxs: 1}"
                >
                </grid-layout>
            </div>
        </v-form>    </div>
</template>


<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import moment from 'moment-timezone';
    import Swatches from 'vue-swatches'
    import IconPicker from './modals/icon-picker'
    import ImagePicker from './imagePicker';
    import ColorPicker from './colorPicker';
    import VueGridLayout from 'vue-grid-layout';

    export default {
        components: {
            Swatches,
            IconPicker,
            ImagePicker,
            ColorPicker,
        },
        data() {
            return {
                title: 'Agregar',
                valid: true,
                sending: false,
                view: false,
                id: '',
                form: {
                },
                rowHeight: 15,
                layout: [
                ],
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            },
            dataInit() {
                var self = this;
                if (this.id) {
                    this.getRegistry(this.id);
                } else {
                    this.$http.get('Orders/form')
                    .then(response => {
                        var newform = response.body.Orders;
                        this.form = newform;
                    });
                }
            },
            getRegistry(id) {
                var self = this;
                this.$http.get('Orders/form/' + this.id)
                .then(response => {
                    self.form = response.body.Orders;
                    
                }, error => {
                    self.snackbar('Error al obtener registro');
                    this.goBack();
                });
            },
            save() {
                self = this;

                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.form.updatedById = localStorage.getItem('userId');
                    if (this.id) {
                        this.$http.put('Orders/' + self.id, self.form)
                            .then(response => {
                                self.snackbar('Registro actualizado con éxito');
                                this.goBack();                               
                            }, error => {
                                self.sending = false;                                
                                var message = 'Error al actualizar registro';
                                self.snackbar(message);
                                console.error(error);
                        });
                    } else {
                        self.form.createdById = localStorage.getItem('userId');
                        self.$http.post('Orders/', self.form)
                            .then(response => {
                                self.snackbar('Registro creado con éxito');
                                this.$router.push('/Orderslist');   
                            }, error => {
                                self.sending = false;                                
                                var message = 'Error al crear registro';
                                self.snackbar(message);
                                console.error(error);
                            });
                    }
                }
            },
            gridItem(id) {
                return this.layout.filter(x => x.i === id)[0];
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Visualizar";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Modificar";
            }
            this.dataInit();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
        computed: {
        }
    }
</script>